module.exports = "https://static.wanderu.com/static/media/location-icon.4ac1f91b.svg";